// assets/cart-delivery-date-init.js
(function(){
  function initDeliveryDatePicker() {
    if (!window.jQuery || !jQuery.ui) return;

    var $input = jQuery("#cart_delivery_date_picker");
    if (!$input.length || $input.hasClass("hasDatepicker")) return;

    // ---------- utilities ----------
    function fmt(date) {
      var mm = ("0"+(date.getMonth()+1)).slice(-2);
      var dd = ("0"+date.getDate()).slice(-2);
      var yyyy = date.getFullYear();
      return mm + "/" + dd + "/" + yyyy;
    }
    function toNoon(d){
      d.setHours(12,0,0,0); // avoid DST weirdness
      return d;
    }

    // Compute earliest allowed date as N *business* days (skip weekends + disabled)
    function computeMinBusinessDate(opts) {
      var start        = toNoon(new Date());
      var needed       = Math.max(0, +opts.businessDays || 0);
      var disabledSet  = new Set((opts.disabledDates || []).map(String));
      var blockSat     = !!opts.blockSaturday;
      var blockSun     = !!opts.blockSunday;
      var d = new Date(start);

      var MAX_TRIES = 500; // safety
      var tries = 0;

      // Walk forward counting only open business days
      while (needed > 0 && tries < MAX_TRIES) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        var weekend = (blockSun && dow === 0) || (blockSat && dow === 6);
        var disabled = disabledSet.has(fmt(d));
        if (!weekend && !disabled) needed--;
        tries++;
      }

      // Ensure landing day is allowed
      tries = 0;
      while (tries < MAX_TRIES) {
        var dow2 = d.getDay();
        var weekend2 = (blockSun && dow2 === 0) || (blockSat && dow2 === 6);
        var disabled2 = disabledSet.has(fmt(d));
        if (!weekend2 && !disabled2) break;
        d.setDate(d.getDate() + 1);
        tries++;
      }
      return d;
    }

    // Keep hidden fields in sync
    function syncFields(dateText) {
      $input.val(dateText);
      jQuery("#CartNote").val(dateText);
      jQuery("#CartDeliveryDate").val(dateText);
    }

    // Lock/Unlock checkout buttons
    function toggleCheckout() {
      var hasDate = !!$input.val();
      // Standard checkout buttons
      jQuery("button[name='checkout'], input[name='checkout']")
        .prop("disabled", !hasDate)
        .attr("aria-disabled", String(!hasDate));

      // Shopify accelerated checkout (Shop Pay / Apple / Google)
      // Most themes render a button element we can disable
      jQuery(".shopify-payment-button__button, .shopify-payment-button button")
        .prop("disabled", !hasDate)
        .attr("aria-disabled", String(!hasDate));

      // Optional: visually dim the whole express checkout block
      jQuery(".shopify-payment-button").css("pointerEvents", hasDate ? "" : "none")
                                       .css("opacity", hasDate ? "" : "0.5");
    }

    // Final safety: prevent form submit without date
    function wireSubmitGuard() {
      // Dawn cart form id can be #Cart (capital) or #cart (lowercase) depending on version/customizations
      var $forms = jQuery("form#Cart, form#cart");
      $forms.off(".deliveryDateGuard").on("submit.deliveryDateGuard", function(e){
        if (!$input.val()) {
          e.preventDefault();
          alert("Please choose a delivery date before checking out.");
          return false;
        }
      });
    }

    // ---------- settings ----------
    var disabled = $input.data("disabled-dates") || [];
    var minBiz   = +($input.data("min-offset") || 0);
    var maxOffM  = +($input.data("max-offset") || 0);
    var blockSat = !!$input.data("block-saturday");
    var blockSun = !!$input.data("block-sunday");

    var minBusinessDate = computeMinBusinessDate({
      businessDays: minBiz,
      disabledDates: disabled,
      blockSaturday: blockSat,
      blockSunday: blockSun
    });

    // ---------- init datepicker ----------
    $input.datepicker({
      minDate: minBusinessDate,
      maxDate: "+" + maxOffM + "M",
      appendTo: "body",
      showOn: "focus",
      dateFormat: "mm/dd/yy",
      beforeShowDay: function(date) {
        var dow = date.getDay();
        var weekend = (blockSat && dow===6) || (blockSun && dow===0);
        var disabledDate = disabled.includes(fmt(date));
        if (weekend || disabledDate) {
          return [false, "ui-state-disabled", "Unavailable"];
        }
        return [true, "", ""];
      },
      onSelect: function(dateText) {
        syncFields(dateText);
        toggleCheckout();
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: { "Delivery Date": dateText },
            note: dateText
          })
        }).catch(function(err){
          console.error("Delivery-date save failed:", err);
        });
      }
    });

    // Open on focus for good UX
    $input.on("focus", function(){ $input.datepicker("show"); });

    // Initial state: if date exists, set & unlock; else lock
    var existing = $input.val();
    if (existing) {
      $input.datepicker("setDate", existing);
      syncFields(existing);
    }
    toggleCheckout();
    wireSubmitGuard();

    // Also respond to manual typing (just in case)
    $input.on("change keyup", function(){
      toggleCheckout();
    });
  }

  document.addEventListener("DOMContentLoaded", initDeliveryDatePicker);
  document.addEventListener("shopify:section:load", initDeliveryDatePicker);
  if (window.jQuery) {
    jQuery(document).on("ajaxcart:updated ajaxCart.afterUpdate cart:refresh", initDeliveryDatePicker);
  }
})();
